/**
 * @generated SignedSource<<dd8362ced7591722ad603fef98a07077>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AbstractBlock_contentBlock$data = {
  readonly text: string;
  readonly " $fragmentType": "AbstractBlock_contentBlock";
};
export type AbstractBlock_contentBlock$key = {
  readonly " $data"?: AbstractBlock_contentBlock$data;
  readonly " $fragmentSpreads": FragmentRefs<"AbstractBlock_contentBlock">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AbstractBlock_contentBlock",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    }
  ],
  "type": "AbstractBlock",
  "abstractKey": null
};

(node as any).hash = "56f2b44ff0f19294a1efe7f2221898c2";

export default node;
